import type { ReactNode, FC } from "react";

import styled from "styled-components";

import { setFont } from "@similarweb/styles";

import { abbrNumberVisitsFilter } from "app/filters/ngFilters";

import { DefaultCell } from "./DefaultCell";

const StyledCell = styled(DefaultCell)`
    ${setFont({ $family: "'Roboto'" })};
    text-align: right;
    justify-content: flex-end;
`;

export const NumberCell: FC<{
    value?: number;
    children?: ReactNode;
    className?: string;
}> = ({ value, children, className }) => {
    // @ts-ignore FIXME: strict migration - Argument of type 'number | undefined' is not assignable to parameter of type 'string | number' — abbrNumberVisitsFilter handles non-number at runtime (returns 0); widening the shared ngFilters signature would mask real errors at other call sites
    const formattedValue = abbrNumberVisitsFilter()(value);
    return <StyledCell className={className}>{children || formattedValue}</StyledCell>;
};
